import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import CoverPage from './components/CoverPage'
import TableOfContents from './components/TableOfContents'
import ChapterView from './components/ChapterView'
import AudioPlayer from './components/AudioPlayer'
import NavigationBar from './components/NavigationBar'
import { ebookData } from './content/ebookData'

const App = () => {
  const [currentView, setCurrentView] = useState('cover')
  const [currentChapter, setCurrentChapter] = useState(0)
  const [isAudioPlaying, setIsAudioPlaying] = useState(false)

  const chapters = ebookData.chapters

  const handleStartReading = () => {
    setCurrentView('contents')
  }

  const handleChapterSelect = (chapterIndex) => {
    setCurrentChapter(chapterIndex)
    setCurrentView('chapter')
  }

  const handleNavigation = (direction) => {
    if (direction === 'next' && currentChapter < chapters.length - 1) {
      setCurrentChapter(prev => prev + 1)
    } else if (direction === 'prev' && currentChapter > 0) {
      setCurrentChapter(prev => prev - 1)
    }
  }

  return (
    <div className="app-container">
      <NavigationBar 
        currentView={currentView}
        onBack={() => setCurrentView(currentView === 'chapter' ? 'contents' : 'cover')}
        showBack={currentView !== 'cover'}
      />

      <main className="main-content">
        <AnimatePresence mode="wait">
          {currentView === 'cover' && (
            <motion.div
              key="cover"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <CoverPage onStart={handleStartReading} />
            </motion.div>
          )}

          {currentView === 'contents' && (
            <motion.div
              key="contents"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.5 }}
            >
              <TableOfContents 
                chapters={chapters}
                onSelectChapter={handleChapterSelect}
              />
            </motion.div>
          )}

          {currentView === 'chapter' && (
            <motion.div
              key={`chapter-${currentChapter}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
            >
              <ChapterView 
                chapter={chapters[currentChapter]}
                chapterIndex={currentChapter}
                totalChapters={chapters.length}
                onNavigate={handleNavigation}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </main>

      {chapters[currentChapter]?.hasAudio && currentView === 'chapter' && (
        <AudioPlayer 
          isPlaying={isAudioPlaying}
          onTogglePlay={() => setIsAudioPlaying(!isAudioPlaying)}
          chapterId={chapters[currentChapter].id}
        />
      )}
    </div>
  )
}

export default App
